// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__3X6HE","heading":"Loader_heading__1aUsQ"};